import React from "react";
import axios from "axios";

import './App.css'

class App extends React.Component {
    state = {
        advice: ""
    };

    componentDidMount() {
        // console.log("Component did Mount");
        this.fetchAdvice();
    }

    fetchAdvice = () => {
        axios.get("https://api.adviceslip.com/advice")
        .then((response)=> {
            const {advice} = response.data.slip;
            // console.log(advice);

            this.setState({advice})
        })
        .catch((error) => {
            console.log(error)
        })
    }

    render(){
        const {advice} = this.state;
        return(
            <div className="app">
                <div className="carding">
                    <h1 className="heading">{advice}</h1>
                    <button className="button waves-effect waves-light btn-large" onClick={this.fetchAdvice}>
                        GIVE ME ADVICE!
                    </button>
                </div>
            </div>
        )
    }
}

export default App;